import { render, staticRenderFns } from "./SplitNameFormPart.vue?vue&type=template&id=24b75cbc"
import script from "./SplitNameFormPart.vue?vue&type=script&lang=js"
export * from "./SplitNameFormPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports